<template>
    <div class="pdd-iframe" :class="{'isIPhoneX': $GY_platform.isIPhoneX }">
        <iframe class="pdd-iframe-con" v-if="actUrl" :src="actUrl" frameborder="0"></iframe>

        <div class="top-btn-wrap">
            <div class="myreward-btn" @click="myRewardOrder">我的奖励</div>
        </div>

        <div class="share-btn-wrap">
            <div class="share-btn" @click="handleShare">分享给好友赚补贴</div>
        </div>

        <van-popup v-model="rulePop" class="rule-pop">
            <div class="pop-con">
                <div class="scroll-wrap">
                    <p><span class="txt-bold">活动时间：</span>6月07日12:00-8月31日23:59</p>
                    <p><span class="txt-bold">活动规则：</span><br>1、活动期间，用户在高佣联盟APP或高佣优选小程序推广补贴商品产生的有效订单，可获得佣金和每单额外补贴；</p>
                    <p>2、若订单发生售后/退货/退款或其他可能导致订单佣金失效的情况，则该笔订单视为无效订单，相应补贴也将从预估补贴中扣除；</p>
                    <p>3、订单明细及佣金收益在高佣联盟-我的-拼多多订单中查看；</p>
                    <p>4、本活动页面仅展示预估补贴，每月最终补贴收益结算为次月30日24点前确认收货的有效订单，补贴将在次次月28日发放至高佣联盟账户余额，可申请提现；（举例：6月5日下单，需在7月30日前确认收货，补贴将于8月28日发放）；</p>
                    <p>5、所产生的订单不能存在流量劫持、刷单等违规行为，一经发现将取消奖励资格。</p>
                    <p>
                        6、仅针对千万补贴精选商品：<br/>
                        （1）秒杀商品：<br/>
                        若为自购，则每个商品每个用户只补贴1单；超过1单后仍可购买，有佣金但无补贴；<br/>
                        若为非自购，则每个商品每个用户补贴3单；超过3单后仍可购买，有佣金但无补贴。<br/>
                        （2）每日11点上新商品：<br/>
                        若为自购，则每个商品每个用户补贴3单，超过3单后仍可购买，有佣金但无补贴；<br/>
                        若为非自购，则每个商品每个用户补贴10单，超过10单后仍可购买，有佣金但无补贴。<br/>
                        PS：非自购：下单和推广者不是同一人。<br/>
                    </p>
                </div>
            </div>
            <div class="close-btn" @click="rulePop = false"></div>
        </van-popup>

        <WeChatShare :show.sync="shareShow" width="25%" :config="['weChat', 'friend', 'saveImg', 'copyLink']" :shareParam="shareParam" popTitle="分享到微信"></WeChatShare>
    </div>
</template>

<script>
import { subsidyInfo } from '@/views/activity2022/api/202204/vip-iframe'
import WeChatShare from "@/common/components/WeChatShare";
import {mapState} from 'vuex'
import Vue from 'vue';
import {Popup} from 'vant';
import {goodsJump} from '@/common/utils'
Vue.use(Popup);
export default {
    name: 'VipIframe',
    components: {
        WeChatShare
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.common.userInfo,
        }),
    },
    data() {
        return {
            actUrl: '',
            actId:null,
            commissionDiscountRate: '',
            rulePop: false,
            shareShow: false,
            shareParam: {
                shareTitle: '唯品会千万补贴',
                shareDesc: '官方爆款指定补贴商品，限时限量抢购',
                posterImg: 'https://statich5.gaoyong2021.com/activity2022/img/vip_iframe/poster.png',
                shareLogo: 'https://statich5.gaoyong2021.com/activity2022/img/vip_iframe/logo.png'
            }
        }
    },
    created() {
        this.$uweb.trackEvent("activity2022", `VIP_唯品会千万补贴官网页浏览量`, this.$GY_platform.currentPlatform);

        // webView 每次显示执行
        window.webViewDidAppear = (url) => {
            window.history.back()
        };

        let query=this.$route.query
        if(query.actId){
            this.actId=query.actId
            this.getActivityInfo()
        }else {
            this.$toast("无法获取活动ID");
        }

    },
    methods: {
        getActivityInfo() {
            const req = {
                userId: this.userInfo.uid,
                userType: this.userInfo.utype,
                actId:this.actId,
            }
            subsidyInfo(req).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    const resData = res.data.data
                    if (resData.url) {
                        this.actUrl = resData.url
                    }

                    this.shareParam.shareLink = resData.shareUrl
                    this.shareParam.copyLink = resData.shareUrl
                }
            })
        },
        //我的奖励订单
        myRewardOrder() {
            if (this.$GY_platform.isGYApp) {
                let obj = {
                    type: 11,
                    appurl: `${window.location.origin}/activity2022/2204/vipIframe/order`
                }
                goodsJump(obj)
            } else {
                this.$router.push({
                    path: '/2204/vipIframe/order'
                })
            }
        },
        // 查看规则
        handleRule() {
            this.$uweb.trackEvent("activity2022", `VIP_唯品会千万补贴官网页_规则按钮点击`, this.$GY_platform.currentPlatform);
            this.rulePop = true
        },
        // 点击分享
        handleShare() {
            this.$uweb.trackEvent("activity2022", `VIP_唯品会千万补贴官网页_分享按钮点击`, this.$GY_platform.currentPlatform);
            this.shareShow = true
        }
    }
}
</script>

<style scoped lang="less">
.pdd-iframe {
    min-height: 100vh;
    position: relative;

    .pdd-iframe-con {
        padding-bottom: 122px;
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
    }

    .top-btn-wrap {
        padding: 20px 15px 20px 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 54px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 18px 0 0 18px;
        line-height: 1;
        font-size: 24px;
        font-weight: bold;
        color: #FFFFFF;
        position: absolute;
        top: 20px;
        right: 0;
        user-select: none;
    }

    .share-btn-wrap {
        width: 750px;
        height: 122px;
        background-color: #FF4433;
        position: fixed;
        left: 0;
        bottom: 0;

        .share-btn {
            margin: 12px auto 0;
            width: 702px;
            height: 98px;
            background: linear-gradient(90deg, #FFE7BB, #FFD281);
            border-radius: 49px;
            line-height: 98px;
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #7F3C00;
            user-select: none;

            &:after {
                content: '';
                margin: 33px 0 0 10px;
                display: inline-block;
                width: 32px;
                height: 32px;
                background-image: url('~@/views/activity2022/assets/img/202204/vip-iframe/ic_arrow_r.png');
                background-size: 100%;
                vertical-align: top;
            }
        }
    }

    &.isIPhoneX {
        .pdd-iframe-con {
            padding-bottom: 162px;
        }

        .share-btn-wrap {
            height: 162px;
        }
    }


    .rule-pop {
        width: 580px;
        background-color: transparent;

        .pop-con {
            padding: 88px 0 30px;
            width: 580px;
            height: 780px;
            background-color: #FFFFFF;
            background-image: url('~@/views/activity2022/assets/img/202204/vip-iframe/pdd_tc_gz.png');
            background-size: 100% auto;
            background-repeat: no-repeat;
            box-shadow: 1px 2px 4px 0 rgba(255, 255, 255, 0.95);
            border-radius: 24px;
            overflow: hidden;
            line-height: 1.5;
            font-size: 26px;
            color: #7A2F39;
            p {
                margin-bottom: 10px;
            }
            .txt-bold {
                font-weight: bold;
            }
            .scroll-wrap {
                padding: 26px 47px 0 30px;
                width: 597px;
                height: 662px;
                overflow-x: hidden;
                overflow-y: scroll;
            }
        }
        .close-btn {
            width: 100%;
            height: 110px;
            background-image: url('~@/views/activity2022/assets/img/202204/vip-iframe/pdd_tc_close_btn.png');
            background-size: 62px 62px;
            background-repeat: no-repeat;
            background-position: center bottom;
        }
    }
}
</style>
